var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KImg',{attrs:{"src":require('../common/hummingbird-small-cc-by-sa-4.jpg'),"altText":"A sitting hummingbird"},scopedSlots:_vm._u([{key:"topLeft",fn:function(){return [_c('span',{staticClass:"label"},[_vm._v(" Top left ")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }